// Interruptor temporal para suspender la CARGA DE VENTAS (el formulario de alta)
// sin afectar el resto de la web (login, estado de cliente, solicitudes, mis
// ventas, panel). Se usa cuando la API de Iptel no está tomando altas.
//
// Para REACTIVAR las ventas: poner VENTAS_SUSPENDIDAS en false y desplegar.
export const VENTAS_SUSPENDIDAS = false;

export const MENSAJE_VENTAS_SUSPENDIDAS =
  "Carga de ventas suspendida temporalmente. Volvé a intentar más tarde.";
